<template>
    <div v-if="frame" :style="wrStyle" style="border-radius: 3px">
        <div v-for="(it, index) in frame" v-if="it.visible" :key="it[idProp]" :style="[index == frame.length -1 ? wLast: wPerc]" 
        style="display: inline-table; position: relative">

            <div class="step" :class="{'right-borderless': it[idProp]==last, 'left-borderless': it[idProp]==first}"
            :style="[defaultStyle, active == it[idProp] ? activeStyle : active > it[idProp] ? doneStyle : todoStyle ]">
                {{showed(it)}}
                <br>
                <div style="display: grid;">
                    <div style="font-size:smaller; font-weight:350; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width: 95%;">{{showedValue(it)}}</div>
                </div>
            </div>

            <!-- cosmetic arrows -->
            <div class="arrow" v-if="it[idProp]!=last" 
            :style="[active == frame[index+1][idProp] ? activeStyle : active > frame[index+1][idProp] ? doneStyle : todoStyle ]"></div>
            <div class="over_arrow" v-if="it[idProp]!=last"
            :style="[active == it[idProp] ? borderActive : active > it[idProp] ? borderDone : borderTodo ]"></div>
           
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            iterated: Array,
            idProp: String,
            visibles: Array,
            activeStep: Number,
            showed: {
                type: Function,
                default(item) {
                    return item[this.idProp];
                }
            },
            showedValue: {
                type: Function,
                default(item) {
                    return item[this.idProp];
                }
            },
            wrStyle: Object,
            defaultStyle: {
                type: Object,
                default() {
                    return {
                        color: '#333'
                    }
                }
            },
            doneStyle: {
                type: Object,
                default() {
                    return {
                       'background-color': 'lightsteelblue'
                    }
                }
            },
            activeStyle: {
                type: Object,
                default() {
                    return {
                        'background-color': 'steelblue',
                        color: 'white'
                    }
                }
            },
            todoStyle: {
                type: Object,
                default() {
                    return {
                        color: '#666',
                        'background-color': '#eee'
                    }
                }
            }
        },
        mounted: function(){
            this.initLocalIterable();
            this.borderDone['border-left-color'] = this.doneStyle['background-color'];
            this.borderActive['border-left-color'] = this.activeStyle['background-color'];
            this.borderTodo['border-left-color'] = this.todoStyle['background-color'];
        },
        data: function(){
            return {
                local: null,
                frame: null,
                active: -1,
                first: null,
                last: null,

                borderDone: {},
                borderActive: {},
                borderTodo: {},
                wPerc: {},
                wLast: {}
            }
        },
        watch: {
            activeStep: function(){
                this.active = this.activeStep;
                this.initLocalIterable();
            }
        }, 
        methods: {
            initLocalIterable: function(){
                var vm = this;
                if(this.visibles != null){
                    try {
                        this.local = this.iterated.map(function(it){
                            it.visible = vm.visibles.indexOf(it[vm.idProp]) != -1;
                            return it;
                        })
                    } catch(err) {
                        console.log("caught in local iterable visible selection:")
                        console.log(err)
                    }
                } else {
                    try {
                        this.local = this.iterated.map(function(it){
                            it.visible = true;
                            return it;
                        })
                    } catch(err) {
                        console.log("caught in local iterable all visibile init:")
                        console.log(err)
                    }
                }
                this.active = this.activeStep;
                this.getEdges();
            },
            getEdges: function(){
                var active_e;
                var vm = this;
                this.frame = this.local.filter(function(e){
                    if(e[vm.idProp] == vm.active){
                        active_e = e;
                    }
                    return e.visible;
                })
                
                var perc = Math.floor(100/this.frame.length);
                var last = perc + (100 % this.frame.length);
                this.wPerc.width = perc+'%';
                this.wLast.width = last+'%';

                this.first = null;
                this.last = null;
                for(var i = 0; i < this.frame.length; i++){
                    if(this.frame[i].visible){
                        this.last = this.frame[i][this.idProp];
                        if(this.first == null){
                            this.first = this.frame[i][this.idProp];
                        }
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .step {
        display: inline-table;
        /*width: 109px;*/
        width: 100%;
        padding: 5px 16px 5px 8px;
        height: 60px;
        text-align: center;
    }  
    .arrow, .over_arrow {
        width: 0px;
        border-top: 30px solid transparent;
        border-bottom: 30px solid transparent;
        border-left: 15px solid white;
        display: table-cell;

        position: absolute;
        right: -1px;
        top: 0px;
        z-index: 9998;
    }
    .over_arrow {
        right: 3px;
    }
    .left-borderless {
        border-radius: 3px 0px 0px 3px;
    }
    .right-borderless {
        border-right-style: none !important;
        /*width: 124px;*/
        border-radius: 0px 3px 3px 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/dynamic/DynSteps.vue?02a1721f